import {
	TAG_FETCH,
	TAG_LOADING_STATUS,
	TAG_FETCH_ERRORS,
	TAG_FETCH_POPULAR,
	TAG_FETCH_POPULAR_ERROR,
	TAG_DELETE,
	TAG_DELETE_ERRORS,
	TAG_ADD,
	TAG_ADD_ERRORS,
	TAG_CLEAR,
} from './types'

const initialState = {
	loading: false,
	popularTagsLoading: false,
	tags: [],
	errors: [],
	tagsMeta: null,
}

export const state = { ...initialState }

export default {
	[TAG_LOADING_STATUS]: (state, status) => {
		state.loading = status
	},

	[TAG_FETCH]: (state, payload) => {
		state.tags = payload.append ? [...state.tags, ...payload.data] : payload.data

		state.tagsMeta = payload.tagsMeta
	},

	[TAG_FETCH_ERRORS]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[TAG_FETCH_POPULAR]: (state, payload) => {
		state.tags = payload
	},

	[TAG_FETCH_POPULAR_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[TAG_DELETE]: (state, id) => {
		state.tags = state.tags.filter((tag) => tag.id !== id)
	},

	[TAG_DELETE_ERRORS]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[TAG_ADD]: (state, payload) => {
		state.tags = [...state.tags, payload]
	},

	[TAG_ADD_ERRORS]: (state, error) => {
		state.errors = [...state.errors, error]
	},
	[TAG_CLEAR]: (state) => {
		state.tags = []
		state.tagsMeta = null
	},
}
